import { lang, t } from "@/i18n";
import { GLOSSARY } from "@/i18n/glossary";

// The dashboard's vocabulary in the active language: one row per term with
// what it is and why it matters. No data fetch — this is reference text, so
// it renders instantly and reads the same on every visit.
export function GlossaryView() {
  const l = lang.value;
  return (
    <div style="display: grid; gap: 24px;">
      <section class="card">
        <p class="panel-help">{t("glossary.intro")}</p>
        <table class="table glossary">
          <thead>
            <tr>
              <th>{t("glossary.term")}</th>
              <th>{t("glossary.what")}</th>
              <th>{t("glossary.why")}</th>
            </tr>
          </thead>
          <tbody>
            {GLOSSARY.map((entry) => (
              <tr key={entry.id} id={`glossary-${entry.id}`}>
                <td class="glossary-term">{entry.term[l]}</td>
                <td>{entry.what[l]}</td>
                <td>{entry.why[l]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
